(() => {
  const root = document.querySelector('.obp-setup-v2');
  if (!root) return;

  root.addEventListener('click', (event) => {
    const button = event.target.closest('.video-placeholder');
    if (!button || !root.contains(button)) return;
    const frame = button.closest('.video-frame');
    const id = frame && frame.dataset.video;
    if (!frame || !id) return;

    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1';
    iframe.title = button.getAttribute('aria-label') || 'One Button Phone Videoanleitung';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    frame.replaceChildren(iframe);
  });
})();

